(ns io.daskul.webapp.widgets.dashboard.stat-group
  "Compact stat group — renders multiple simple counts in a single row.

   Expects a metric map with :widget :stat-group shape:
     {:widget :stat-group
      :key    \"active-counts\"
      :stats  [{:label \"Active Students\" :value 7 :format :number}
               {:label \"Active Programs\" :value 7 :format :number}]}"
  (:require
   [uix.core :refer [defui $]]
   [io.daskul.webapp.ui :as ui]))

(defn- format-value [value fmt]
  (case (keyword (or fmt :number))
    :currency (.toLocaleString (js/Number. value) "en-PH"
                #js {:style "currency" :currency "PHP"
                     :minimumFractionDigits 0 :maximumFractionDigits 0})
    :percent  (str (.toFixed (* 100 value) 1) "%")
    (str value)))

(defui stat-group
  "Renders a compact horizontal row of label:value pairs in a single card."
  [{:keys [stats]}]
  ($ ui/paper {:p "md" :radius "md" :withBorder true}
    ($ ui/group {:gap "xl" :wrap "wrap"}
      (for [s stats]
        ($ :div {:key (:label s)}
          ($ ui/text {:size "xs" :tt "uppercase" :fw 600 :c "dimmed" :mb 2}
            (:label s))
          ($ ui/text {:size "xl" :fw 700 :lh 1}
            (format-value (:value s) (:format s))))))))
